const targetStructure = {
  dfsSchemeApplication: {
    farmerId: null,
    mdmsId: null,
    rowVersion: 0,
    schemeApplication: {
      appliedDate: null,
      applicationType: "",
      cdpCropDemand: [
        {
          appliedArea: null,
          appliedPlant: null,
          cropCode: null,
          cropName: null,
        },
      ],
      documents: [],
      farmerProfile: {
        aadharNo: null,
        bankDetails: {
          accountNo: null,
          bankName: null,
          ifscCode: null,
        },
        blockCode: null,
        blockCodeC: null,
        blockName: null,
        casteCategory: null,
        dbtRegistrationNo: null,
        districtCode: null,
        districtCodeC: null,
        districtName: null,
        dob: null,
        fatherOrHusbandName: null,
        farmerType: null,
        gender: null,
        location: null,
        maritalStatus: null,
        mobileNo: null,
        name: null,
        panchayatCode: null,
        panchayatCodeC: null,
        panchayatName: null,
        villageCode: null,
        villageCodeC: null,
        villageName: null,
        relation: null,
        vitalStatus: null,
      },
      landDetails: [
        {
          areaInAcres: null,
          khasraNo: null,
          khataNo: null,
        },
      ],
      landLocation: {
        isLandLocationSame: null,
        landBlockCode: null,
        landBlockCodeC: null,
        landBlockName: null,
        landDistrictCode: null,
        landDistrictCodeC: null,
        landDistrictName: null,
        landPanchayatCode: null,
        landPanchayatCodeC: null,
        landPanchayatName: null,
        landVillageCode: null,
        landVillageCodeC: null,
        landVillageName: null,
        pinCode: null,
        sectionApply: null,
      },
      schemeSpecificAttributes: {
        applicantType: null,
        appliedforOI: null,
        applyForInc: null,
        company1: null,
        company2: null,
        company3: null,
        componentCode: null,
        componentName: null,
        cropCode: null,
        cropName: null,
        cropUnit: null,
        componentPreviousSubsidy: null,
        bankFinInstitute: null,
        oiInstallationCompany: null,
        refrence: null,
        referenceid: null,
        refrenceother: null,
        selfDeclaration: null,
        subInc: null,
        subIncName: null,
        subsidySelf: null,
        appliedAreaQuantity: null,
        appliedForFoodGradeContainer: null,
        applicantFrom: null,
        ngoGroupName: null,
        ngoGroupRegNo: null,
        ngoGroupRegDate: null,
        userIP: null,
        applicationId: null,
        appliedAreaDropDown: null,
        farmerCat: null,
        totalRakwa: null,
        effectedCrop: null,
        effectedRakwa: null,
        kharpatwar: null,
        prest1: null,
        prestQ1: null,
        prest2: null,
        prestQ2: null,
        prest3: null,
        prestQ3: null,
        prest4: null,
        prestQ4: null,
        prest5: null,
        prestQ5: null,
        noOfApply: null,
        honeyBeeTrainingFrom: null,
        conpanyBased: null,
        waterPump: null,
        irrigationSource: null,
      },
      billDetails: [
        {
          billNo: null,
          amount: null,
          purchaseDate: null,
        },
      ],
      schemeName: null,
      selfDeclaration: null,
      billDetails: [],
      memberDetails: [],
      varietyDemand: [],
    },
    schemeId: null,
    tenantId: null,
    additionalFields: {
      fields: [
        {
          key: null,
          value: null,
        },
      ],
      schema: "FARMER",
      version: null,
    },
    status: null,
  },
};

export default targetStructure;
